import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Button,
  Typography,
  LinearProgress,
  useTheme,
} from "@mui/material";
import "./index.css";
import { CustomButton } from "../../components/Button";
import AboutYou from "./AboutYou";
import { ReactComponent as BackIcon } from "../../assets/images/arrow-left-02.svg";
import { ReactComponent as NextIcon } from "../../assets/images/arrow-right-icon.svg";
import { ReactComponent as DoneIcon } from "../../assets/images/tick-double-04.svg";
import WorkAndPersonality from "./WorkAndPersonality";
import GoalsAndInterests from "./GoalsAndInterests";
import CommunicationPreferences from "./CommunicationPreferences";
import { useDispatch, useSelector } from "react-redux";
import {
  useCreatePersonalThreadMutation,
  useGetPersonalThreadQuery,
  useUpdatedPersonalMemoryMutation,
  useUpdatePersonalThreadMutation,
} from "../../services/user";
import { errorToast, successToast } from "../../utils/toast";
import { setOnboarding } from "../../rtkSlices/onboardingSlice";
import { setUser } from "../../rtkSlices/metaDataSlice";
import { useNavigate } from "react-router-dom";

const Onboarding = (props: {
  update: boolean;
  setUpdateOnboarding: (value: boolean) => void;
  refetch: () => void;
}) => {
  const [open, setOpen] = useState(true);
  const onboarding = useSelector((state: any) => state.onboarding);
  console.log({ onboarding });
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = useState(0);
  const handleClose = () => setOpen(false);
  const [updateOnboardingProcess] = useUpdatePersonalThreadMutation();
  const [updatePersonalMemory, updateMemoryResult] =
    useUpdatedPersonalMemoryMutation();
  const metaData = useSelector((state: any) => state.metaData);
  const username = metaData.userInfo["cognito:username"];
  const getPersonalThread = useGetPersonalThreadQuery(`?username=${username}`);
  const [createPersonalThread, createPersonalThreadResult] =
    useCreatePersonalThreadMutation();
  const theme = useTheme();
  const [personalData, setPersonalData] = useState<any>({});
  const [aboutYouForm, setAboutYouForm] = useState({});
  const navigate = useNavigate();
  const getStarted = () => {
    const tempSteps = [...steps];
    tempSteps[0].active = true;
    setSteps(tempSteps);
    setActiveStep(1);
  };

  useEffect(() => {
    if (!getPersonalThread.isFetching && getPersonalThread.isSuccess) {
      //   setPersonalData(getPersonalThread.data);
      dispatch(setOnboarding(getPersonalThread.data));
      const {
        age,
        language,
        profilePicture,
        name,
        location,
        nickname,
        llm,
        occupation,
      }: any = getPersonalThread.data ?? {};
      setAboutYouForm({
        age,
        language,
        profilePicture,
        name,
        location,
        nickname,
        llm,
        occupation,
      });
      //   dispatch(setOnboarding(getPersonalThread.data));
    }
  }, [getPersonalThread.isFetching]);
  useEffect(() => {
    getPersonalThread.refetch();
  }, [props.update]);

  const [steps, setSteps] = useState([
    {
      component: <AboutYou setAboutYouForm={setAboutYouForm} />,
      active: false,
      step: 1,
      label: "About",
    },
    {
      component: <WorkAndPersonality />,
      active: false,
      step: 2,
      name: "Work & Personality",
      label: "Work & Personality",
    },
    {
      component: <GoalsAndInterests interests={false} />,
      active: false,
      step: 3,
      name: "Goals & Interests",
      label: "Goals",
    },
    {
      component: <GoalsAndInterests interests={true} />,
      active: false,
      step: 4,
      name: "Interests",
      label: "Interests",
    },
    {
      component: <CommunicationPreferences boresponse={false} />,
      active: false,
      step: 5,
      name: "Commuincation Preferences",
      label: "Commuincation",
    },
    {
      component: <CommunicationPreferences boresponse={true} />,
      active: false,
      step: 6,
      name: "Bo Responses",
      label: "Responses",
    },
    {
      name: "Create Personal Thread",
      active: false,
      step: 7,
    },
  ]);

  const stepProgress = () => {
    let progress: any =
      steps.find((step) => step.active) &&
      steps.find((step) => step.active)?.step;
    return (
      <LinearProgress
        variant="determinate"
        value={progress * 16.66}
        sx={{
          width: "100%",
          backgroundColor: "rgba(52, 180, 116, 0.5)",
          borderRadius: "3px",
        }}
      />
    );
  };

  const getNextStepName = () => {
    const index = steps.findIndex((step) => step.active);
    if (steps[index + 1]) {
      return steps[index + 1].name;
    }
  };

  const goToNextStep = async () => {
    let tempSteps = [...steps];
    const index = tempSteps.findIndex((step) => step.active);
    if (activeStep != 6) {
      tempSteps[index].active = false;
      if (tempSteps[index + 1]) {
        tempSteps[index + 1].active = true;
      }
      setActiveStep(activeStep + 1);
      setSteps(tempSteps);
      if (index + 1 == 1) {
        dispatch(setOnboarding(aboutYouForm));
      }
    }
    const response: any = await updateOnboardingProcess({
      body: index + 1 == 1 ? aboutYouForm : onboarding.onboarding,
      params: `?username=${username}`,
    });
    if (response.error) {
      errorToast(
        response.error.error ||
          (response.error.data && response.error.data.message)
      );
    } else {
      if (!props.update && activeStep == 6) {
        const body = {
          username,
          ai_llm: onboarding.onboarding.llm,
          temperature: 0.7,
        };
        const response: any = await createPersonalThread(body);
        if (response.error) {
          errorToast(
            response.error.error ||
              (response.error.data && response.error.data.message)
          );
        } else {
          successToast(
            response.data.message ||
              "Personal Thread has been created successfully"
          );
          navigate("/chat");
          dispatch(
            setUser({ isOnboardingCompleted: true, personalThread: true })
          );
        }
      }
    }
  };
  const goBack = () => {
    let tempSteps = [...steps];
    const index = tempSteps.findIndex((step) => step.active);
    tempSteps[index].active = false;
    if (tempSteps[index - 1]) {
      tempSteps[index - 1].active = true;
    }
    setActiveStep(activeStep - 1);
    setSteps(tempSteps);
  };

  const updateMemory = async () => {
    const {
      age,
      language,
      profilePicture,
      name,
      location,
      nickname,
      llm,
      occupation,
    }: any = aboutYouForm;
    dispatch(
      setOnboarding({
        age,
        language,
        profilePicture,
        name,
        location,
        nickname,
        llm,
        occupation,
      })
    );
    const body = {
      username,
      ai_llm: llm,
      updatedMemory: {
        ...onboarding.onboarding,
        ...{
          age,
          language,
          profilePicture,
          name,
          location,
          nickname,
          llm,
          occupation,
        },
      },
    };
    const response: any = await updatePersonalMemory(body);
    if (response.error) {
      errorToast(
        response.error.error ||
          (response.error.data && response.error.data.message)
      );
    } else {
      successToast(
        response.data.message || "Personal Thread has been updated successfully"
      );
      //   setPersonalData(onboarding.onboarding);
      props.setUpdateOnboarding(false);
      props.refetch();
    }
  };

  const skipOrUpdate = () => {
    return (
      <div className="skipOrUpdate">
        <div className="skip" onClick={() => props.setUpdateOnboarding(false)}>
          Skip
        </div>
        <CustomButton
          text={
            updateMemoryResult.isLoading
              ? ""
              : "Update and Return to Personal Thread"
          }
          fontSize="13px"
          width="300px"
          borderRadius="20px"
          variant="outlined"
          bgcolor="initial"
          border="1px solid #30A46C"
          color="#30A46C"
          submit={updateMemory}
        />
      </div>
    );
  };

  const goToStep = (step: number) => {
    const tempSteps = [...steps];
    tempSteps.forEach((t) => (t.active = false));
    if (step) {
      tempSteps[tempSteps.findIndex((s) => s.step == step)].active = true;
    }
    setSteps(tempSteps);
    setActiveStep(step);
  };

  const breadcrumbs = () => {
    return (
      <div
        className="breadcrumb"
        style={{
          color: theme.palette.mode == "dark" ? "lightgrey" : "#30a46c",
        }}
      >
        {[
          ...[{ label: "Home", active: !activeStep ? true : false, step: 0 }],
          ...steps.slice(0, 6),
        ].map((step: any, ind) => {
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "1px" }}>
              <div
                className={step.active ? "active-step" : "step"}
                onClick={() => goToStep(step.step)}
              >
                {step.label}
              </div>
              <span>{step.step != 6 ? " /" : null}</span>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        sx={{ zIndex: "99999 !important" }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "1%",
            left: "1%",
            width: "98vw",
            height: "98vh",
            bgcolor: "background.paper",
            boxShadow: 24,
            overflow: "auto",
            borderRadius: 2,
            zIndex: 99999,
            backgroundColor: theme.palette.background.default,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {props.update ? (
            <Box
              sx={{
                padding: "20px 100px",
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                position: "absolute",
              }}
            >
              {breadcrumbs()} {skipOrUpdate()}{" "}
            </Box>
          ) : null}
          <Box
            sx={{
              //   height: "88vh",
              height: "90%",
              width: "100%",
              overflow: "auto",
              paddingTop: 4,
              paddingBottom: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {!steps.find((step) => step.active) ? (
              <>
                <Typography
                  fontSize={"53px"}
                  fontFamily={"Fredoka"}
                  fontWeight={"600"}
                >
                  {props.update
                    ? "Let's update your personality"
                    : "Let's personalize your HiiBo"}
                </Typography>
                <br />
                <Typography
                  fontSize={"24px"}
                  fontFamily={"Poppins"}
                  fontWeight={"400"}
                >
                  Answer a few quick questions so Bo can genuinely understand
                  and support you.
                </Typography>
                <br />
                <CustomButton
                  text={"Get started"}
                  width="200px"
                  submit={getStarted}
                />
              </>
            ) : (
              steps.map((step) => step.active && step.component)
            )}
          </Box>
          {steps.find((step) => step.active) ? (
            <Box
              sx={{
                height: "10%",
                backgroundColor: theme.palette.background.default,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                width: "450px",
              }}
            >
              <div className="back" onClick={goBack}>
                <BackIcon />
              </div>
              {stepProgress()}
              <CustomButton
                text={
                  createPersonalThreadResult.isLoading ? "" : getNextStepName()
                }
                disabled={props.update && activeStep == 6}
                fontSize="12px"
                width="90%"
                endIcon={
                  props.update &&
                  activeStep ==
                    6 ? undefined : createPersonalThreadResult.isLoading ? undefined : activeStep ==
                    6 ? (
                    <DoneIcon
                      style={{
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  ) : (
                    <NextIcon style={{ width: "20px", height: "20px" }} />
                  )
                }
                submit={goToNextStep}
              />
            </Box>
          ) : null}
        </Box>
      </Modal>
    </div>
  );
};

export default Onboarding;
